import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from "react-redux";
import {get, map} from 'lodash';
import classNames from 'classnames';

import {FILTER_1} from "../../../../../reducers/performance_reducers";
import {
    SetDashboardFiltersAction,
    CleanDashboardDataAction
} from "../../../../../actions/performance_actions";

const DATA_TYPES = {
    'general': {
        'math': 'Math Practices',
        'domain': 'Math Domains',
        'ela': 'ELA Targets',
        'claim': 'CAASPP Claims'
    },
    'student': {
        'math': 'Math Practices',
        'ela': 'ELA Targets'
    }
}

export default function ({dataMode, dataType, setDataType}) {
    const dispatch = useDispatch();

    const dashboard_filters = useSelector(state => state.dashboard_filters);

    const onClick = (data_type_key) => () => {
        if (data_type_key == dataType) {
            return;
        }

        setDataType(data_type_key);
    }

    const render_data_types = map(DATA_TYPES[dataMode], (data_type_name, data_type_key) => {
        const class_names = classNames("pam-selection-one-type btn", {
            "btn-challenge": data_type_key == dataType,
            "btn-flat": data_type_key != dataType,
        });
        return (
            <div key={data_type_key} className={class_names} onClick={onClick(data_type_key)}>
                {`${data_type_name}`}
            </div>
        );
    });

    return (
        <div className="pam-selection-types">
            <div className="flex-row flex-v-center flex-gap-20">
                <div className="pam-selection-types-title">
                    {`Student Achievement:`}
                </div>
                {render_data_types}
            </div>
        </div>
    );
}
